// Separar e apagar anotações do atendimento: a MESMA regra de backend/utils/anotacoes.py.
// As anotações moram num texto só, a mais nova no topo. Uma anotação começa depois de
// uma linha em branco ou numa linha "[DD/MM/AAAA] ...": alguns avisos automáticos
// (veredito da casa, crítico, item postado) entram com uma quebra só.

const DATA = /^\[\d{2}\/\d{2}\/\d{4}\]/;

// Decisão da Adneia (19/10/2026): só o usuário dela, que é admin, apaga anotação.
// A tela só esconde a lixeira; quem barra de verdade é o servidor.
const APAGAR_ANOTACAO_EMAILS = ['adneia@weconnect360.com.br'];

export function podeApagarAnotacao(user) {
  const email = String((user && user.email) || '').trim().toLowerCase();
  return !!user && user.role === 'admin' && APAGAR_ANOTACAO_EMAILS.includes(email);
}

// Quem escreveu (Adnéia, 28/10/2026): a anotação feita por uma pessoa leva o nome dela no
// fim, como o Retorno à Sicredi já faz: "[28/10/2026] Acionado Matheus (Caio Rossi)". As
// automáticas do ELO não passam por aqui. Sem nome (sessão sem usuário), fica como antes.
export function novaEntrada(texto, nome, hoje) {
  const t = String(texto || '').trim();
  const n = String(nome || '').trim();
  const base = `[${hoje}] ${t}`;
  if (!n || t.endsWith(`(${n})`)) return base;
  return `${base} (${n})`;
}

export function separarSpans(anotacoes) {
  const texto = anotacoes || '';
  const spans = [];
  let ini = null;
  let fim = null;
  let pos = 0;
  texto.split('\n').forEach((linha) => {
    const linIni = pos;
    const linFim = pos + linha.length;
    pos = linFim + 1;
    if (!linha.trim()) {
      if (ini !== null) { spans.push([ini, fim]); ini = null; }
      return;
    }
    if (ini !== null && DATA.test(linha)) { spans.push([ini, fim]); ini = null; }
    if (ini === null) ini = linIni;
    fim = linFim;
  });
  if (ini !== null) spans.push([ini, fim]);
  return spans;
}

export function separarEntradas(anotacoes) {
  const texto = anotacoes || '';
  return separarSpans(texto).map(([a, b]) => texto.slice(a, b));
}

// O texto sem a anotação `indice` e sem o separador colado nela; o resto fica igual.
export function semEntrada(anotacoes, indice) {
  const texto = anotacoes || '';
  const spans = separarSpans(texto);
  if (indice < 0 || indice >= spans.length) return texto;
  const [a, b] = spans[indice];
  let resto;
  if (indice > 0) resto = texto.slice(0, spans[indice - 1][1]) + texto.slice(b);
  else if (spans.length > 1) resto = texto.slice(0, a) + texto.slice(spans[1][0]);
  else resto = texto.slice(0, a) + texto.slice(b);
  return resto.trim() ? resto : '';
}
